import Vue from 'vue';

Vue.filter('capitalize', (val) => val.toUpperCase());

Vue.filter('read_more', (val) =>
  val.length > 130 ? `${val.substring(0, 130 - 3)}...` : val
);

Vue.filter('two_digits', (val) => {
  if (val.toString().length <= 1) {
    return `0${val.toString()}`;
  }
  return val.toString();
});
